/* src/app/admin-dashboard/svinn-report/svinn-report-popup/svinn-report-popup.component.css */
.popup-header {
  background-color: var(--custom-color);
  color: white;
  height: 90px;
  width: "auto";
  font-size: 20px;
  padding: 30px;
}
.popup-table th,
.popup-table td {
  padding: 8px 10px;
  border: 1px solid #e0e0e0;
  text-align: left;
}
.popup-table th {
  background-color: #f4f6f8;
  font-weight: 600;
  color: #333;
}
.popup-table .center {
  text-align: center;
}
.popup-table tr:nth-child(even) td {
  background-color: #fafafa;
}
.popup-table tr:hover td {
  background-color: #eef7ff;
}
.popup-empty {
  text-align: center;
  color: #777;
  padding: 12px 0;
}
/*# sourceMappingURL=svinn-report-popup.component.css.map */
